(function () {
  'use strict';
  if (window.__PW_PERFORMANCE_CLEANUP__) return;
  window.__PW_PERFORMANCE_CLEANUP__ = true;

  function cleanup() {
    var preloader = document.getElementById('pw-preloader');
    if (preloader) preloader.remove();

    document.querySelectorAll('a.__click-overlay').forEach(function (overlay) {
      overlay.remove();
    });

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanup, { once: true });
  } else {
    cleanup();
  }
  window.setTimeout(cleanup, 1200);
})();


(function () {
  'use strict';

  if (window.__PW_CHRISTMAS_BANNER_SNOW__) return;
  if (window.location.pathname !== '/') return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  window.__PW_CHRISTMAS_BANNER_SNOW__ = true;

  function startChristmasSnow() {
    if (document.getElementById('pw-christmas-snow')) return;

    var christmasLink = document.querySelector('.ai-split-slideshow__slide a[href*="/collections/christmas"]');
    var slide = christmasLink ? christmasLink.closest('.ai-split-slideshow__slide') : null;

    if (!slide) {
      var slides = document.querySelectorAll('.ai-split-slideshow__slide');
      for (var s = 0; s < slides.length; s += 1) {
        if ((slides[s].textContent || '').toLowerCase().indexOf('christmas') !== -1) {
          slide = slides[s];
          break;
        }
      }
    }

    if (!slide) return;

    var style = document.createElement('style');
    style.id = 'pw-christmas-snow-style';
    style.textContent = [
      '#pw-christmas-snow{position:absolute;inset:0;overflow:hidden;pointer-events:none;z-index:3;contain:layout paint}',
      '#pw-christmas-snow .pw-snowflake{position:absolute;top:-12%;left:var(--left);font-size:var(--size);line-height:1;color:#fff;text-shadow:0 1px 4px rgba(15,39,27,.3);opacity:var(--opacity);will-change:transform;animation:pwChristmasSnowFall var(--duration) linear var(--delay) infinite}',
      '#pw-christmas-snow.is-paused .pw-snowflake,.ai-split-slideshow__slide:not(.is-active) #pw-christmas-snow .pw-snowflake{animation-play-state:paused}',
      '@keyframes pwChristmasSnowFall{0%{transform:translate3d(0,-12%,0) rotate(0deg)}50%{transform:translate3d(var(--drift),56vh,0) rotate(180deg)}100%{transform:translate3d(0,118vh,0) rotate(360deg)}}',
      '@media (prefers-reduced-motion:reduce){#pw-christmas-snow{display:none!important}}'
    ].join('');
    document.head.appendChild(style);

    var snow = document.createElement('div');
    snow.id = 'pw-christmas-snow';
    snow.setAttribute('aria-hidden', 'true');

    var count = window.innerWidth <= 767 ? 18 : 32;
    var fragment = document.createDocumentFragment();

    for (var i = 0; i < count; i += 1) {
      var flake = document.createElement('span');
      flake.className = 'pw-snowflake';
      flake.textContent = '\u2744';
      flake.style.setProperty('--left', (Math.random() * 100).toFixed(2) + '%');
      flake.style.setProperty('--size', (8 + Math.random() * 12).toFixed(1) + 'px');
      flake.style.setProperty('--opacity', (0.4 + Math.random() * 0.5).toFixed(2));
      flake.style.setProperty('--duration', (7 + Math.random() * 7).toFixed(2) + 's');
      flake.style.setProperty('--delay', (-Math.random() * 14).toFixed(2) + 's');
      flake.style.setProperty('--drift', (-28 + Math.random() * 56).toFixed(1) + 'px');
      fragment.appendChild(flake);
    }

    snow.appendChild(fragment);
    slide.appendChild(snow);

    document.addEventListener('visibilitychange', function () {
      snow.classList.toggle('is-paused', document.hidden);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startChristmasSnow, { once: true });
  } else {
    startChristmasSnow();
  }
})();
